import React, { useEffect, useState } from 'react';

const parts = (ms) => {
  const s = Math.max(0, Math.floor(ms / 1000));
  return {
    days: Math.floor(s / 86400),
    hours: Math.floor((s % 86400) / 3600),
    mins: Math.floor((s % 3600) / 60),
    secs: s % 60,
  };
};

const torontoLabel = (iso) => {
  try {
    return new Intl.DateTimeFormat('en-CA', {
      timeZone: 'America/Toronto', dateStyle: 'medium', timeStyle: 'short',
    }).format(new Date(iso));
  } catch {
    return '';
  }
};

/** Live countdown to `targetIso`. `label` describes what the countdown is for. */
const VotingCountdown = ({ targetIso, label = 'Voting closes in', onElapsed }) => {
  const [remaining, setRemaining] = useState(() => new Date(targetIso).getTime() - Date.now());

  useEffect(() => {
    const t = setInterval(() => {
      const r = new Date(targetIso).getTime() - Date.now();
      setRemaining(r);
      if (r <= 0 && onElapsed) onElapsed();
    }, 1000);
    return () => clearInterval(t);
  }, [targetIso, onElapsed]);

  if (!targetIso || Number.isNaN(new Date(targetIso).getTime())) return null;
  const { days, hours, mins, secs } = parts(remaining);
  const done = remaining <= 0;

  return (
    <div data-testid="voting-countdown" className="inline-block">
      <p className="text-xs tracking-[2px] uppercase mb-2" style={{ color: '#FDB913' }}>
        {done ? 'Voting has closed' : label}
      </p>
      {!done && (
        <div className="flex gap-2 sm:gap-3">
          {[['Days', days], ['Hrs', hours], ['Min', mins], ['Sec', secs]].map(([l, v]) => (
            <div key={l} className="rounded-lg px-3 py-2 min-w-[58px] text-center" style={{ background: 'rgba(255,255,255,0.12)', border: '1px solid rgba(253,185,19,0.3)' }}>
              <div className="text-2xl sm:text-3xl font-bold tabular-nums" style={{ fontFamily: 'Georgia, serif' }}>
                {String(v).padStart(2, '0')}
              </div>
              <div className="text-[10px] uppercase tracking-wide opacity-80">{l}</div>
            </div>
          ))}
        </div>
      )}
      <p className="mt-2 text-xs opacity-75">Closes {torontoLabel(targetIso)} (Toronto time)</p>
    </div>
  );
};

export default VotingCountdown;
